// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-xcz","colBig":"styles_colBig__2gA0D","colSmall":"styles_colSmall__CGDfV"};